import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Configurer from "../components/Configurer";
import { checkTranslation, translate } from "../utils/useful";
import HomeDashboard from "../components/boxes/HomeDashboard";
import { siteTheme, siteConfig } from "../variables/config";
import TLink from "../components/TLink";
import store from "../stores/storeConfig";

class UserDashboards extends React.Component {
    state = {
        modules: [],
    }

    componentDidMount() {
        // Get user type from user info or test environment
        const userType = siteConfig.testEnv && this.props.testUserType 
            ? this.props.testUserType 
            : this.props.user?.info?.userType

        console.log('UserDashboards - componentDidMount, userType:', userType, 'testEnv:', siteConfig.testEnv, 'testUserType:', this.props.testUserType)
        if (userType) {
            this.setModulesForUserType(userType)
        } else {
            console.log('UserDashboards - No userType found')
        }
    }

    componentDidUpdate(prevProps) {
        // Update modules if user type changes (for test environment)
        const currentUserType = siteConfig.testEnv && this.props.testUserType 
            ? this.props.testUserType 
            : this.props.user?.info?.userType

        const prevUserType = siteConfig.testEnv && prevProps.testUserType 
            ? prevProps.testUserType 
            : prevProps.user?.info?.userType

        if (currentUserType !== prevUserType) {
            this.setModulesForUserType(currentUserType)
        }
    }

    setModulesForUserType = (userType) => {
        let modules = []
        
        if (userType === 'veterinarian') {
            modules = [
                {
                    description: translate('View and manage your operations'),
                    showInDashboard: true,
                    title: translate('My Operations'),
                    key: 'operations',
                    image: '/images/kheiry/Veterinarian.png',
                    page: 'operations',
                    defaultAccess: true,
                },
            ]
        } else if (userType === 'horseBreeder') {
            modules = [
                {
                    description: translate('View and manage your orders'),
                    showInDashboard: true,
                    title: translate('My Orders'),
                    key: 'orders',
                    image: '/images/kheiry/horsebreeder.png',
                    page: 'orders',
                    defaultAccess: true,
                },
            ]
        }

        this.setState({ modules })
    }

    render() {
        const userType = siteConfig.testEnv && this.props.testUserType 
            ? this.props.testUserType 
            : this.props.user?.info?.userType
        const userTypeName = userType === 'veterinarian' 
            ? translate('Veterinarian') 
            : userType === 'horseBreeder' 
                ? translate('Horse Breeder') 
                : translate('User')

        return (
            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTranslation(this.props.title), button: {} }}
                title={checkTranslation(this.props.title)}
                description={this.props.description}
                className=""
            >
                <div className="row m-0">
                    <div className="col-12 px-4 container">
                        <div className="px-4 mt-4">
                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                                {/* Header Section with Logo and Title - Left Side */}
                                <div className="d-flex align-items-center mb-3 mb-md-0">
                                    <TLink
                                        className="hover-scale-sm"
                                        to={'/'}
                                        onClick={() => store.dispatch(actions.initHeader(''))}
                                        style={{ display: 'flex', alignItems: 'center' }}
                                    >
                                        <img className="" src={siteTheme.logo2} height={40} alt="" />
                                    </TLink>
                                    <div className="mld-3">
                                        <p
                                            className="text-normal mb-1"
                                            style={{ color: '#222', fontWeight: 600, fontSize: 18 }}
                                        >
                                            {checkTranslation(this.props.title)}
                                        </p>
                                        <p
                                            className="text-smaller mb-0"
                                            style={{ color: '#666', fontSize: 14 }}
                                        >
                                            {checkTranslation(this.props.description)} - {userTypeName}
                                        </p>
                                    </div>
                                </div>

                                {/* Modules Section - Right Side, In Front */}
                                <div className="d-flex flex-wrap gap-3" style={{ flex: '0 0 auto' }}>
                                    {this.state.modules && this.state.modules.length > 0 ? (
                                        this.state.modules.map((prop, index) => {
                                            return (
                                                <div key={index} style={{ minWidth: 280, maxWidth: 320 }}>
                                                    <div className="w-100 h-100" style={{ background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                                        <HomeDashboard data={prop} />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <div className="text-center p-4">
                                            <p style={{ color: '#999', fontSize: 14 }}>
                                                {userType ? `Loading dashboard for ${userTypeName}...` : 'No user type selected'}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Configurer>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserDashboards);

